import { render, staticRenderFns } from "./DetailBarang.vue?vue&type=template&id=3951e5ec&"
import script from "./DetailBarang.vue?vue&type=script&lang=js&"
export * from "./DetailBarang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports